<div mat-dialog-content *ngIf="type == 'toppers'"> 
  <ng-container *ngIf="data?.viewtype == 'video' || !data?.viewtype"> 
    <object class="videotab" style="width: 100%;
    height: 64vh;" [data]="video">
      <param name="movie" 
             [value]="video"/>
      <param name="allowScriptAccess" value="always"/>
    </object>
  </ng-container>
  <ng-container *ngIf="data?.viewtype == 'image'"> 
   <img [src]="data?.video" style="width:100%;">
  </ng-container>
  <div class="desk-none">
    <button class="align-center " (click)="close()" mat-button>Close</button>
  </div>
</div>



<div mat-dialog-content *ngIf="type != 'toppers'">
  <div class="row">
<div class="col-md-8" style="padding-top: 5px;padding-left: 20px;">
  <object class="videotab" style="width: 100%;
  height: 63vh;" [data]="video">
    <param name="movie" 
           [value]="video"/>
    <param name="allowScriptAccess" value="always"/>
  </object>
</div>
<div class="col-md-4 pl-md-0 justify-content-center">
<div>

    <div class="infodiv">
        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/video_info_p_opt.png">
        <div class="contdiv">
          <p >Build your Own Success Today</p>
          <p>Be a part of Our Learning Network</p>
          <h4>Contact us to know more</h4>
          <p>info@iquanta.in</p>
          <p>+91 8130900243</p>
        </div>
        <button class="desk-now-show" (click)="close()" mat-button>Close</button>
    </div>
</div>
</div>
  </div>
 


 

 
</div>

<div class="closebtn" (click)="close()">
 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28" fill="none">
                            <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                            <path
                                d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                fill="#1E1515" />
                        </svg>
</div>